module.exports = __webpack_public_path__ + "static/media/Rubik-Regular.422055d2.woff";